import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { IMAGE_URL } from "network";
import Swal from "sweetalert2";
import { useGetConcernsQuery } from "slices/wellness/concernSlice";
import { useAddServiceMutation } from "slices/wellness/doctorSlice";
import { useNavigate } from "react-router-dom";

function Step2({ val, onNext }) {
  const navigate = useNavigate();
  const [uploadDoc] = useAddServiceMutation();
  const { data } = useGetConcernsQuery({});

  const validationSchema = Yup.object().shape({
    services: Yup.array()
      .of(Yup.string())
      .min(1, "Select at least one service"),
  });

  console.log("val", val);

  const initialValues = {
    user_id: val?._id,
    concerns: [],
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        let response = await uploadDoc(values);
        console.log("response", response);
        if (response?.data) {
          console.log("response", response);
          navigate("/wellness/doctors");
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response?.message,
          });
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        setFieldValue,
        isSubmitting,
      }) => (
        <Form>
          <Box className="container py-4">
            <Typography variant="h5" gutterBottom>
              Select Concerns
            </Typography>

            <Box display="flex" flexWrap="wrap" gap={2} mt={2}>
              {data?.data?.map((item) => {
                const isSelected = values.concerns.includes(item._id);
                return (
                  <Paper
                    key={item._id}
                    onClick={() => {
                      const currentServices = values.concerns || [];
                      if (currentServices.includes(item._id)) {
                        setFieldValue(
                          "concerns",
                          currentServices.filter((id) => id !== item._id)
                        );
                      } else {
                        setFieldValue("concerns", [
                          ...currentServices,
                          item._id,
                        ]);
                      }
                    }}
                    sx={{
                      width: 150,
                      padding: 2,
                      textAlign: "center",
                      border: isSelected
                        ? "2px solid #1976d2"
                        : "1px solid #ccc",
                      cursor: "pointer",
                      backgroundColor: isSelected ? "#e3f2fd" : "#fff",
                      transition: "all 0.3s",
                    }}
                  >
                    <Box
                      crossOrigin="anonymous"
                      component="img"
                      src={`${IMAGE_URL}${item.image}`}
                      alt={item.name}
                      sx={{
                        width: 60,
                        height: 60,
                        objectFit: "cover",
                        mb: 1,
                      }}
                    />
                    <Typography variant="subtitle2">{item.title}</Typography>
                  </Paper>
                );
              })}
            </Box>

            <Box display="flex" justifyContent="flex-end" mt={4}>
              <Button type="submit" variant="contained" disabled={isSubmitting}>
                Submit
              </Button>
            </Box>
          </Box>
        </Form>
      )}
    </Formik>
  );
}

export default Step2;
